import { CompaniesPageCategory, showPrefectureNameInTitleFlag } from '@constants_iqfu';
import { CompaniesPageQueryType } from 'src/iqfu/data/companiesPagesData';

import { CityInfo } from '../../type-def/public/CityDetailData';

export const getCompaniesPageMetaInfo: any = {
  getCompaniesCityMetaTitle: (
    isValidUrl: boolean,
    prefectureName: string,
    cityName: string,
    queryTypeString: typeof CompaniesPageCategory[keyof typeof CompaniesPageCategory],
  ) => {
    return isValidUrl
      ? `【${
          showPrefectureNameInTitleFlag ? prefectureName : ''
        }${cityName}版】${queryTypeString}地元の不動産屋さんランキング|不動産売却・買取専門のイクラ不動産 ${prefectureName}${cityName}出張所`
      : '';
  },
  getCompaniesCityMetaDescription: (
    isValidUrl: boolean,
    prefectureName: string,
    cityName: string,
    propertyTypeString: string | undefined,
    queryTypeString: typeof CompaniesPageCategory[keyof typeof CompaniesPageCategory],
  ) => {
    const conditionalSentence1 = propertyTypeString
      ? `${propertyTypeString}の売却に強い`
      : queryTypeString === CompaniesPageCategory.default
      ? '「土地・（中古）マンション・（中古）一戸建て」の売却・買取・査定に強くて得意な'
      : queryTypeString;

    return isValidUrl
      ? `「イクラ不動産　${prefectureName}${cityName}出張所」の「【${prefectureName}${cityName}版】${queryTypeString}地元の不動産屋さんランキング」のページです。「イクラ不動産　${prefectureName}${cityName}出張所」おすすめの地元で${
          queryTypeString === CompaniesPageCategory.default ? '売却実績が豊富な' : queryTypeString
        }地元の不動産会社を、おすすめ順にランキング形式で掲載しています。弊社で審査して厳選した、地元で${conditionalSentence1}おすすめの地元の不動産会社をランキング形式で比較検討できます。併せて、${prefectureName}${cityName}の不動産売却市場・相場の動向や売れ筋物件の傾向、実際にあった売却事例まで、不動産売却をするにあたって必要な情報も掲載しています。`
      : '';
  },
  getCompaniesPrefectureMetaTitle: (
    isValidUrl: boolean,
    prefectureName: string,
    queryTypeString: typeof CompaniesPageCategory[keyof typeof CompaniesPageCategory],
    pageQueryType: CompaniesPageQueryType,
  ) => {
    return isValidUrl
      ? `【${prefectureName}版】${queryTypeString}地元の不動産屋さんランキング${
          pageQueryType !== 'leaseback' && pageQueryType !== 'purchase' ? 'TOP10' : ''
        }|不動産売却・買取専門のイクラ不動産 ${prefectureName}支店`
      : '';
  },
  getCompaniesPrefectureMetaDescription: (
    isValidUrl: boolean,
    prefectureName: string,
    propertyTypeString: string | undefined,
    queryTypeString: typeof CompaniesPageCategory[keyof typeof CompaniesPageCategory],
    pageQueryType: CompaniesPageQueryType,
  ) => {
    const conditionalSentence1 = propertyTypeString
      ? `${propertyTypeString}の売却に強い`
      : queryTypeString === CompaniesPageCategory.default
      ? '「土地・（中古）マンション・（中古）一戸建て」の売却・買取・査定に強くて得意な'
      : queryTypeString;

    return isValidUrl
      ? `「イクラ不動産　${prefectureName}支店」の「【${prefectureName}版】${queryTypeString}不動産屋さんランキング${
          pageQueryType !== 'leaseback' && pageQueryType !== 'purchase' ? 'TOP10' : ''
        }」のページです。「イクラ不動産　${prefectureName}支店」おすすめの地元で${
          queryTypeString === CompaniesPageCategory.default ? '売却実績が豊富な' : queryTypeString
        }地元の不動産会社を、おすすめ順に${
          pageQueryType !== 'leaseback' && pageQueryType !== 'purchase' ? 'TOP10まで' : ''
        }ランキング形式で掲載しています。弊社で審査して厳選した、地元で${conditionalSentence1}おすすめの不動産会社をランキング形式で比較検討できます。併せて、${prefectureName}の不動産売却市場・相場の動向や売れ筋物件の傾向、実際にあった売却事例まで、不動産売却をするにあたって必要な情報も掲載しています。`
      : '';
  },
  getCompaniesCountryMetaTitle: (queryTypeString: typeof CompaniesPageCategory[keyof typeof CompaniesPageCategory]) => {
    return `【全国版】${queryTypeString}不動産屋さんランキング|不動産売却・買取専門のイクラ不動産　全国本店`;
  },
  getCompaniesCountryMetaDescription: (
    queryTypeString: typeof CompaniesPageCategory[keyof typeof CompaniesPageCategory],
    propertyTypeString: string | undefined,
  ) => {
    const conditionalSentence1 = propertyTypeString
      ? `${propertyTypeString}の売却に強くて得意な`
      : queryTypeString === CompaniesPageCategory.default
      ? '「土地・（中古）マンション・（中古）一戸建て」の売却・買取・査定に強くて得意な'
      : queryTypeString;
    return `「イクラ不動産　全国本店」の「${queryTypeString}不動産屋さんランキング」のページです。「イクラ不動産　全国本店」おすすめの${
      queryTypeString === CompaniesPageCategory.default ? '売却実績が豊富な' : queryTypeString
    }不動産会社を、４７都道府県毎におすすめ順にTOP３まで掲載しています。弊社で審査して厳選した、${conditionalSentence1}おすすめの不動産会社をランキング形式で比較検討できます。併せて、全国の不動産売却市場・相場の動向や売れ筋物件の傾向、実際にあった売却事例まで、不動産売却をするにあたって必要な情報も掲載しています。`;
  },
  getCompaniesCityBreadCrumbsData: (
    cityInfo: CityInfo,
    queryTypeString: typeof CompaniesPageCategory[keyof typeof CompaniesPageCategory],
    pageQueryType: CompaniesPageQueryType,
  ) => {
    return [
      { label: 'Home', url: '/' },
      { label: `全国の${queryTypeString}不動産会社`, url: `/companies/${pageQueryType}` },
      {
        label: `【${cityInfo?.prefecture?.name}版】${queryTypeString}おすすめの不動産屋さんランキング${
          pageQueryType !== 'leaseback' && pageQueryType !== 'purchase' ? 'TOP10' : ''
        }`,
        url: `/companies/prefectures/${cityInfo?.prefecture?.code}/${pageQueryType}`,
      },
      ...(cityInfo.city_category === 'major_city_ward' && cityInfo.parent_major_city
        ? [
            {
              label: `【${showPrefectureNameInTitleFlag ? cityInfo?.prefecture?.name : ''}${
                cityInfo?.parent_major_city?.name
              }版】${queryTypeString}おすすめの不動産屋さんランキング`,
              url: `/companies/cities/${cityInfo?.parent_major_city?.code}/${pageQueryType}`,
            },
          ]
        : []),
      {
        label: `【${showPrefectureNameInTitleFlag ? cityInfo?.prefecture?.name : ''}${
          cityInfo?.city?.name
        }版】${queryTypeString}おすすめの不動産屋さんランキング`,
        url: './',
      },
    ];
  },

  getCompaniesPrefectureBreadCrumbsData: (
    prefectureName: string,
    queryTypeString: typeof CompaniesPageCategory[keyof typeof CompaniesPageCategory],
    pageQueryType: CompaniesPageQueryType,
  ) => {
    return [
      { label: 'Home', url: '/' },
      {
        label: `【全国版】${queryTypeString}おすすめの不動産屋さんランキング`,
        url: `/companies/${pageQueryType}`,
      },
      {
        label: `【${prefectureName}版】${queryTypeString}おすすめの不動産屋さんランキング${
          pageQueryType !== 'leaseback' && pageQueryType !== 'purchase' ? 'TOP10' : ''
        }`,
        url: './',
      },
    ];
  },
  getCompaniesCountryBreadCrumbsData: (
    queryTypeString: typeof CompaniesPageCategory[keyof typeof CompaniesPageCategory],
    pageQueryType: CompaniesPageQueryType,
  ) => {
    return [
      { label: 'Home', url: '/' },
      {
        label: `【全国版】${queryTypeString}不動産屋さんランキング`,
        url: `/companies/${pageQueryType}`,
      },
    ];
  },
};
